<template>
    <div class="dc-catalogues">
        <app-docs :docs="catalogues" :list="false"></app-docs>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import catalogues from './catalogues.json'
import ShareButton from "../shared/ShareButton";
import Docs from "../shared/Docs";
export default {
  components: {
    appShareButton: ShareButton,
    appDocs: Docs
  },
  data() {
      return {
          catalogues: catalogues
      }
  }
};</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/download-center/Catalogues.vue